import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { v4 as uuidGen } from 'uuid';

import { fetchAdsSegmentData } from '../api';

const getAmexAdsSegmentThunk = createAsyncThunk(
  'amexAds/getAmexAdsSegmentThunk',
  ({ requestPage, encryptedResyAdsId }) => fetchAdsSegmentData({
    requestPage,
    encryptedResyAdsId,
    correlationId: uuidGen(),
  })
);

const amexAdsSlice = createSlice({
  name: 'amexAds',
  initialState: {
    isLoading: true,
    flags: null,
    payload: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAmexAdsSegmentThunk.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getAmexAdsSegmentThunk.fulfilled, (state, action) => {
      state.isLoading = false;
      state.flags = action.payload?.flags;
      state.payload = action.payload?.payload;
    });
    builder.addCase(getAmexAdsSegmentThunk.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error;
      state.flags = null;
      state.payload = null;
    });
  },
});

const fetchAmexAdsSegmentThunk = ({ requestPage, encryptedResyAdsId }) => (dispatch) => dispatch(getAmexAdsSegmentThunk({
  requestPage,
  encryptedResyAdsId,
}));

export { fetchAmexAdsSegmentThunk, getAmexAdsSegmentThunk };

export default amexAdsSlice.reducer;
